import loadEvents from './loadEvents';
import { IEventObservable } from '../../types/interfaces/event';
import { setSplash } from '@shared/store/slices/app.slice';
import { store } from '@shared/store/store';
import eventsObservable, {
  EventsRequestType,
} from '../../api/events/eventsObservable';

export default function initEvents(hideSplash = false) {
  eventsObservable(EventsRequestType.NEXT_HOURS).subscribe({
    next: (val: IEventObservable) => {
      if (val.events) {
        loadEvents(val.events);
      }
    },
    error: () => {
      console.error('Error recovering events');
    },
    complete: () => {
      hideSplash && store.dispatch(setSplash({ display: false }));
      return null;
    },
  });
}
